import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/blast-battery/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/blast-battery',
  name: 'activity_blast_battery',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '爆破英雄赏金猎人',
  },
}

export default [indexRoute]
